import React from 'react';
import Modal from '@roo/roo/Modal';
import { getStorage, setStorage } from '@utils/localStorage';
import * as Ids from '@utils/ids';
import { getMajorDisputeAuditGray } from '@business/pages/OrderManage/History/components/AfterSaleAudit/AfterSaleAuditApi';
import pageJump from '@projects/Shell/utils/pageJump';

const CACHE_KEY = 'AfterSaleAuditRemind';

/** 订单系统完单方案优化新功能引导提示 */
const AfterSaleAuditRemind = () => {
    const cachedPoiList = getStorage(CACHE_KEY) || '';
    const wmPoiId = Ids.getWmPoiId();
    if (
        wmPoiId !== '-1' &&
        getMajorDisputeAuditGray() &&
        cachedPoiList.indexOf(`${wmPoiId},`) === -1
    ) {
        Modal.confirm({
            title: '售后服务考核上线',
            children: (
                <div>
                    <p>
                        为帮助商家更好处理售后问题，提升顾客消费体验，即日起平台将增设售后服务考核，根据“平台介入率”及“商责有责率”两个指标评定商家售后表现。请您关注售后服务质量，避免产生违规。
                    </p>
                </div>
            ),
            confirmText: '了解详情',
            cancelText: '知道了',
            onConfirm: () => {
                pageJump.go('/new_fe/business#/order/refundReportInfo');
            },
        });
        setStorage(CACHE_KEY, `${cachedPoiList}${wmPoiId},`);
    }
};

export default AfterSaleAuditRemind;
